import React, { useEffect, useState } from "react";
import { useSpace } from "../../Contexts/SpaceContext";
import { useCurrentAccount } from "../../Contexts/UserContext";
import api from "../../api";
import { handleError } from "../../Helpers/MiscHelper";
import { useToast } from "../Toast/ToastProvider";
import Button from "../Button/Button";
import { spaceSchema } from "../../config/schema";
import dayjs from "dayjs";

const users = [
  "903b311e-06fa-4217-9c43-7e9a2c204bf5",
  "6e3b9234-4155-465b-b68c-cc9a10a660b5",
  "dc28ee22-5088-43f7-83c1-5552b7d99868",
];

const DiskSpaceNotifier = ({ children }) => {
  const userAccountSpace = useCurrentAccount();
  const space = useSpace();
  const createToast = useToast();
  const [alreadyShown, setAlreadyShown] = useState(false);
  const { DbFreeDisk } = space || {};

  useEffect(() => {
    if (
      !alreadyShown &&
      users.includes(userAccountSpace.Id) &&
      DbFreeDisk?.Percentage < 15
    ) {
      const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        api
          .get(`spaces/${space.Id}/CommonTools/CheckSpace`, {
            schema: spaceSchema,
          })
          .then((r) => {
            const t = document.getElementById("DBFreeSpaceGB-handleIt");
            t.textContent = "("+r.DbFreeDisk.DBFreeSpaceGB;
            const s = document.getElementById("DBLastRUN-handleIt");
            s.textContent = dayjs(r.DbFreeDisk.LastRun).format("DD/MM/YYYY HH:mm");
          })
          .catch((e) => {
            handleError(createToast, "Ocorreu um erro");
          });
      };

      const description = (
        <div className="d-flex flex-column justify-content-end align-items-center">
          <div className="fw-bold fs-18 mt-2">
            <span className="mr-1">
              Capacidade de armazenamento abaixo de: 15%
            </span>
            <span id="DBFreeSpaceGB-handleIt">
              ({`${DbFreeDisk.DBFreeSpaceGB}`}
            </span>
            <span>GB)</span>
          </div>
          <Button
            className="mt-3 mb-2"
            style={{ width: 150 }}
            vType="primary"
            onClick={handleClick}
          >
            Atualizar
          </Button>
          <div className="float-right fs-14">
            Ultima Atualização:{" "}
            <span id="DBLastRUN-handleIt">{dayjs(DbFreeDisk.LastRun).format("DD/MM/YYYY HH:mm")}</span>
          </div>
        </div>
      );

      createToast({
        pos: "bl",
        title: "Aviso",
        type: "danger",
        noTimeout: true,
        description,
      });

      setAlreadyShown(true);
    }
  }, [
    DbFreeDisk,
    alreadyShown,
    createToast,
    space,
    userAccountSpace.Id,
    userAccountSpace.IsDeveloper,
  ]);

  return <>{children}</>;
};

export default DiskSpaceNotifier;
